import React, { useEffect, useState } from 'react';
import { CMSService } from '../../../../../services';

const IdentityDownload = ({onLoad}) => {
  const [content, setContent] = useState(undefined);

  const loadHtmlFromCMS = async () => {
    try {
      const [response] = await Promise.all([
        CMSService.getContent('admin-identidade-conteudo', 'content')
      ]);

      setContent(response.content);
    } catch (e) {
      console.error(e);
    }
    onLoad();
  };
  
  useEffect(() => {
    loadHtmlFromCMS();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default IdentityDownload;